import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  CircularProgress,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TableColumn from "./TableCell";
import { useNavigate } from "react-router-dom";

interface Column {
  key: string;
  label: string;
}

interface CreateTableProps<T> {
  loading: boolean;
  data: T[];
  columns: Column[];
  onCheckboxClick?: (row: T, e: React.ChangeEvent<HTMLInputElement>) => void;
  renderActions?: (row: T) => React.ReactNode;
  customRender?: { [key: string]: (value: any, row: T) => React.ReactNode };
}

export default function CreateTable({
  loading,
  data,
  columns,
  renderActions,
  onCheckboxClick,
  customRender,
}: CreateTableProps<any>) {
  const navigate = useNavigate();
  const handleCellClick = (id:string) => {
    navigate(`/orders/${id}`);
  };

  if (loading) return <CircularProgress />;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ border: 1, borderColor: "divider" }}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableColumn dataKey={col.key} label={col.label} key={col.key} />
            ))}
            {renderActions && <TableColumn label={"Actions"} dataKey="actions" />}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id} hover>
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  
                  sx={{
                border: 1,
                borderColor: "divider",
                cursor: col.key === "orderId" ? "pointer" : "default",
                color: col.key === "orderId" ? "blue" : "inherit",
              }}
              onClick={col.key === "orderId" ? () => handleCellClick(row.orderId) : undefined}
                >
                  {customRender?.[col.key]
                    ? customRender[col.key](row[col.key], row)
                    : col.key === "image" ? (
                        <img
                          src={getValue(row, col.key)}
                          width="40"
                          height="40"
                          style={{ borderRadius: "50%" }}
                        />
                      ) : col.key === "is_active" ? (
                        <Checkbox
                          checked={row.is_active}
                          onChange={(e) => onCheckboxClick?.(row, e)}
                        />
                      ) : (
                        getValue(row, col.key) ?? "—"
                      )}
                </TableCell>
              ))}
              {renderActions && renderActions(row)}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function getValue(obj: any, key: string): any {
  return key.split(".").reduce((acc, part) => acc?.[part], obj);
}
